// ServiceCard.jsx
// A REUSABLE component for displaying service information
// This shows the power of React - create once, use many times!

import React from 'react';
import '../styles/ServiceCard.css';

// PROPS EXPLAINED:
// Props are like function parameters - data passed from parent component
function ServiceCard({ icon, title, description, features }) {
  return (
    <div className="service-card">
      {/* Service Icon */}
      <div className="service-icon">{icon}</div>
      
      {/* Service Title */}
      <h3>{title}</h3>
      
      {/* Service Description */}
      <p>{description}</p>
      
      {/* Service Features List */}
      <ul>
        {/* 
          MAP FUNCTION EXPLAINED:
          - features is an array like ['Feature 1', 'Feature 2', 'Feature 3']
          - map() loops through each item and creates JSX for each
          - (feature, index) => feature is the item, index is its position
          - key={index} helps React track each item efficiently
        */}
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
    </div>
  );
}

export default ServiceCard;

/*
UNDERSTANDING PROPS:

When we use this component:
<ServiceCard 
  icon="👗"
  title="Designer Blouses"
  description="Beautiful blouses..."
  features={['Custom designs', 'Premium fabric']}
/>

Inside ServiceCard:
- {icon} becomes "👗"
- {title} becomes "Designer Blouses"
- {description} becomes "Beautiful blouses..."
- {features} becomes the array ['Custom designs', 'Premium fabric']

This makes the component REUSABLE - we can create different service cards
by just passing different props!
*/

/*
THE MAP FUNCTION IN DETAIL:

Without map:
  <li>Custom designs</li>
  <li>Premium fabric</li>
  <li>Traditional styles</li>
  // What if we have 100 features? We'd need 100 lines!

With map:
  {features.map((feature, index) => (
    <li key={index}>{feature}</li>
  ))}
  // This works for any number of features!

The map function:
1. Takes each item from the array
2. Runs a function on it
3. Returns new JSX for each item
4. Combines all results into a list
*/
